const left_part = window.location.host

export const base_url = () => {
  // if(process.env.NODE_ENV === 'development') return 'https://bleplayer.im-fine.dev/api'
  return `https://${left_part}/api`;
};